import React from "react";

function ChevroletIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1800"
      height="1000"
      viewBox="0 0 402.756 192.756"
    >
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <defs>
          <path id="aGradChevy" d="M-96.986-127.216h789.247V969.106H-96.986z" />
        </defs>
        <clipPath id="bGradChevy">
          <use overflow="visible" xlinkHref="#a" />
        </clipPath>
        <g clipPath="url(#b)">
          <path
            fill="#c7d6ee"
            d="M176.76 470.69c1.346 3.083 2.503 5.587 10.98 5.587h48.93c2.697 0 5.392 1.349 5.392 5.199v13.67c0 1.55 1.543 3.672 5.587 3.672h101.33c2.887 0 5.203-1.543 5.203-5.203v-10.79c0-2.888 1.346-5.97 5.585-5.97h81.292c2.888 0 6.741-.768 5.01-4.432-1.738-3.656-28.126-57.194-29.917-60.772-.687-1.371-1.22-3.198-6.564-3.198h-49.972c-2.369 0-6.26 0-6.26-4.581V391.13c0-1.833-1.372-4.582-5.723-4.582H247.376c-3.13 0-5.418 1.609-5.418 4.735V402.5c0 2.442-1.299 6.025-4.96 6.025H152.84c-2.673 0-5.19 2.062-3.587 6.026 1.603 3.972 27.506 56.139 27.506 56.139"
          />
        </g>
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="cGradChevy"
          x1="-1699.285"
          x2="-1698.285"
          y1="-91.81"
          y2="-91.81"
          gradientTransform="matrix(-30.0925 -59.8742 -63.275 .1709 -56765.508 -101262.11)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#c7d6ee" />
          <stop offset=".185" stopColor="#91afc8" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#cGradChevy)"
          d="M155.686 420.508l2.339-.008 22.994 45.751-2.34.007-22.993-45.75z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <defs>
          <path id="dGradChevy" d="M-96.986-127.216h789.247V969.106H-96.986z" />
        </defs>
        <clipPath id="eGradChevy">
          <use overflow="visible" xlinkHref="#d" />
        </clipPath>
        <g clipPath="url(#e)">
          <path
            fill="#e9cf98"
            d="M237.197 414.047h-78.71c-2.746 0-3.708 1.255-2.64 3.39 5.96 11.853 25.56 50.836 26.067 51.871.596 1.217 2.04 2.705 4.704 2.705h52.818c5.48 0 6.413 2.395 6.413 6.721v12.884c0 1.733 1.15 2.885 3.171 2.885h96.738c2.6 0 3.75-.859 3.75-2.592v-9.518c0-3.75-.71-9.805 7.65-9.805h79.937c3.59 0 4.522-2.42 2.622-6.253-7.074-14.27-24.48-48.105-25.022-49.253-.685-1.459-2.814-2.743-6.215-2.743h-52.47c-4.33 0-8.653-2.884-8.653-7.213v-10.995c0-2.002-1.202-3.42-3.342-3.42h-93.867c-2.904 0-4.012 1.644-4.012 3.837v10.004c0 3.458-2.307 7.495-8.939 7.495"
          />
          <path
            fill="#fff"
            d="M342.163 416.627l11.025-11.49s.787 2.52 3.777 3.144l-12.347 11.517s-1.983-1.122-2.455-3.17M237.453 408.442s4.41-.16 4.41-5.985l10.234 15.118-2.834 2.047-11.81-11.18zM346.232 465.688l11.625 11.331s-1.576.193-3.156 2.756l-11.527-11.725 3.058-2.362zM341.205 488.84l10.74 9.159s1.183-.687 1.675-1.773l-11.232-10.344-1.183 2.958zM242.139 494.683c0 1.897 1.762 4.135 4.647 4.135l8.148-10.073s-2.44 0-2.822-.9c-.388-.9-.772-2.826-.772-2.826l-9.201 9.664zM238.622 476.54s3.482.552 3.482 4.274l8.077-9.503-5.148-3.721-6.411 8.95z"
          />
        </g>
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="fGradChevy"
          x1="-1697.484"
          x2="-1696.484"
          y1="-88.19"
          y2="-88.19"
          gradientTransform="rotate(-45 -48890.923 -104610.196) scale(52.096 -51.1672)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e1e8f5" />
          <stop offset=".899" stopColor="#92a5c1" />
          <stop offset=".955" stopColor="#476886" />
          <stop offset="1" stopColor="#e1e8f5" />
        </linearGradient>
        <path
          fill="url(#fGradChevy)"
          d="M298.345 498.818l-.371-4.333h46.543c1.528 0 2.386-.384 2.962-1.529l5.154 4.582s-1.296 1.28-3.654 1.28h-50.634z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="gGradChevy"
          x1="-1701.599"
          x2="-1700.599"
          y1="-83.679"
          y2="-83.679"
          gradientTransform="matrix(37.6845 37.6844 37.0127 -37.0126 67478.602 61509.406)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e1e8f5" />
          <stop offset=".039" stopColor="#476886" />
          <stop offset=".09" stopColor="#92a5c1" />
          <stop offset="1" stopColor="#e1e8f5" />
        </linearGradient>
        <path
          fill="url(#gGradChevy)"
          d="M246.785 498.818c-1.241 0-2.674-.614-3.434-1.565l3.34-3.627s.667.859 3.34.859h47.943l.371 4.333h-51.56z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="hGradChevy"
          x1="-1700.688"
          x2="-1699.688"
          y1="-74.355"
          y2="-74.355"
          gradientTransform="matrix(12.27 11.4419 11.2379 -12.0512 21942.299 19044.457)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e1e8f5" />
          <stop offset=".157" stopColor="#c7d6ee" />
          <stop offset="1" stopColor="#e1e8f5" />
        </linearGradient>
        <path
          fill="url(#hGradChevy)"
          d="M242.139 494.682v-13.206c0-2.073-.415-2.581-.415-2.581l3.685-3.916s.527 1.352.527 2.183v13.085c0 .826.074 2.03.074 2.03l-3.46 4.285s-.411-.749-.411-1.88"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="iGradChevy"
          x1="-1714.481"
          x2="-1713.481"
          y1="-88.15"
          y2="-88.15"
          gradientTransform="matrix(-12.9917 12.115 -11.899 -12.7601 -22965.822 20127.197)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e1e8f5" />
          <stop offset=".157" stopColor="#c7d6ee" />
          <stop offset="1" stopColor="#e1e8f5" />
        </linearGradient>
        <path
          fill="url(#iGradChevy)"
          d="M349.583 492.679s-.1-1.536-.1-2.362c0-.826.1-11.981.1-12.809 0-.826 1.203-2.358 1.203-2.358l4.409 3.902s-1.046.351-1.046 2.424v13.206c0 1.131-.925 1.88-.925 1.88l-3.641-3.883z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="jGradChevy"
          x1="-1701.621"
          x2="-1700.621"
          y1="-84.144"
          y2="-84.144"
          gradientTransform="matrix(42.2657 42.2657 41.5123 -41.5122 75608.86 68884.86)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#476886" />
          <stop offset=".129" stopColor="#92a5c1" />
          <stop offset=".129" stopColor="#92a5c1" />
          <stop offset="1" stopColor="#e1e8f5" />
        </linearGradient>
        <path
          fill="url(#jGradChevy)"
          d="M236.948 476.262c-1.382 0-48.863-.055-51.393-.055-3.671 0-5.83-1.619-5.83-1.619l3.02-4.063s1.208 1.489 3.874 1.489h53.577c1.866 0 3.268.844 3.268.844l-3.501 4.205s-1.719-.801-3.015-.801"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="kGradChevy"
          x1="-1727.241"
          x2="-1726.24"
          y1="-82.108"
          y2="-82.108"
          gradientTransform="matrix(-4.953 7.0736 6.9475 4.8647 -7828.896 13029.844)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#002334" />
          <stop offset=".107" stopColor="#fff" />
          <stop offset=".107" stopColor="#fff" />
          <stop offset=".185" stopColor="#91afc8" />
          <stop offset=".242" stopColor="#002334" />
          <stop offset=".534" stopColor="#5e738f" />
          <stop offset=".758" stopColor="#002334" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#kGradChevy)"
          d="M154.267 417.082l-5.475-3.84s-.434-1.587.384-2.841c.82-1.25 2.072-1.444 2.072-1.444l7.126 5.09s-4.033.19-2.355 3.177c1.678 2.988 1.587 4.113 1.587 4.113 0 .001-1.958-.321-3.339-4.255"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="lGradChevy"
          x1="-1703.671"
          x2="-1702.671"
          y1="-92.986"
          y2="-92.986"
          gradientTransform="matrix(-38.1417 -19.411 -19.065 37.4617 -66571.32 -29136.217)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#91afc8" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#lGradChevy)"
          d="M169.301 454.679c-4.366-8.986-19.03-37.853-19.543-38.884-.514-1.027-1.029-2.823-1.029-2.823l5.651 4.11 26.479 52.752s-7.191-6.164-11.558-15.155"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="mGradChevy"
          x1="-1712.376"
          x2="-1711.376"
          y1="-79.636"
          y2="-79.636"
          gradientTransform="matrix(-2.9241 16.5835 16.2879 2.872 -3512.111 29030.844)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a5b9cc" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#mGradChevy)"
          d="M158.487 413.923l-7.263-5.225s82.73-.204 84.82-.204c2.087 0 2.964-.399 2.964-.399l3.726 4.234s-3.559 1.594-5.536 1.594h-78.711z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="nGradChevy"
          x1="-1667.482"
          x2="-1666.482"
          y1="-56.256"
          y2="-56.256"
          gradientTransform="matrix(4.859 0 0 -4.7724 8344.388 131.311)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#5e738f" />
          <stop offset=".489" stopColor="#91afc8" />
          <stop offset=".489" stopColor="#91afc8" />
          <stop offset="1" stopColor="#91afc8" />
        </linearGradient>
        <path
          fill="url(#nGradChevy)"
          d="M241.13 405.779s.762-1.531.762-2.752v-10.939c0-1.565.61-2.922.61-2.922l3.635 4.282v13.104c0 2.091-1.153 3.85-1.153 3.85l-3.854-4.623z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="oGradChevy"
          x1="-1729.523"
          x2="-1728.523"
          y1="-62.356"
          y2="-62.356"
          gradientTransform="matrix(-6.016 0 0 -5.9087 -10052.35 31.774)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#5e738f" />
          <stop offset=".32" stopColor="#91afc8" />
          <stop offset=".32" stopColor="#91afc8" />
          <stop offset="1" stopColor="#91afc8" />
        </linearGradient>
        <path
          fill="url(#oGradChevy)"
          d="M347.346 407.905V394.8l5.705-4.99s.141 1.33.141 2.892v10.944c0 1.22.354 1.988.354 1.988l-4.988 4.987s-1.212-.621-1.212-2.716"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="pGradChevy"
          x1="-1703.253"
          x2="-1702.253"
          y1="-81.167"
          y2="-81.167"
          gradientTransform="matrix(16.4561 28.5028 27.9947 -16.1627 30619.506 47614.227)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a5b9cc" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#pGradChevy)"
          d="M343.079 392.614h-44.848v-6.086h49.627c1.687 0 3.654 1.122 4.028 1.407l-5.624 5.333s-.371-.654-3.183-.654"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="qGradChevy"
          x1="-1695.336"
          x2="-1694.336"
          y1="-90.087"
          y2="-90.087"
          gradientTransform="matrix(16.5838 -28.724 -28.212 -16.2882 25839.67 -49765.258)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#002334" />
          <stop offset=".775" stopColor="#a5b9cc" />
          <stop offset="1" stopColor="#a5b9cc" />
        </linearGradient>
        <path
          fill="url(#qGradChevy)"
          d="M244.212 387.287s1.155-.819 4.383-.819c3.225 0 49.636.059 49.636.059v6.086h-47.902c-.867 0-1.447.161-1.447.161l-4.67-5.487z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="rGradChevy"
          x1="-1700.355"
          x2="-1699.355"
          y1="-88.448"
          y2="-88.448"
          gradientTransform="matrix(74.0596 -128.2749 -125.9883 -72.7393 115000.453 -224065.328)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffefcf" />
          <stop offset=".461" stopColor="#ffe4a6" />
          <stop offset="1" stopColor="#bc956e" />
        </linearGradient>
        <path
          fill="url(#rGradChevy)"
          d="M257.095 488.869c-2.598 0-5.192-1.444-5.192-4.329v-14.132c0-2.881-1.732-4.036-3.75-4.036h-57.43c-2.333 0-4.138-.973-5.175-2.936-.849-1.613-15.191-30.358-19.826-39.648-1.005-2.015-.127-3.24 2.452-3.24h80.27c3.459 0 4.037-3.174 4.037-6.344v-10.982c0-2.023 2.017-4.33 4.325-4.33h40.381v89.977h-40.092z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="sGradChevy"
          x1="-1701.845"
          x2="-1700.845"
          y1="-80.605"
          y2="-80.605"
          gradientTransform="matrix(20.7733 23.1557 22.7429 -20.4029 37557.992 38161.809)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#5e738f" />
          <stop offset=".607" stopColor="#91afc8" />
          <stop offset=".607" stopColor="#91afc8" />
          <stop offset="1" stopColor="#c7dff4" />
        </linearGradient>
        <path
          fill="url(#sGradChevy)"
          d="M351.127 412.717l4.624-4.753s1.154.639 6.55.639h49.314c1.025 0 2.438.515 2.438.515l-26.068 5.264s-30.18-.021-31.592 0a4.216 4.216 0 0 1-.159.003c-3.06 0-5.107-1.668-5.107-1.668"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="tGradChevy"
          x1="-1697.914"
          x2="-1696.914"
          y1="-89.246"
          y2="-89.246"
          gradientTransform="matrix(27.5792 -47.7685 -46.917 -27.0875 43027.508 -83030.031)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e1e8f5" />
          <stop offset=".815" stopColor="#7f97b4" />
          <stop offset=".815" stopColor="#7f97b4" />
          <stop offset=".904" stopColor="#476886" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#tGradChevy)"
          d="M352.864 473.429s2.254-.753 4.094-.753h77.647c2.363 0 3.742-.176 3.742-.176l6.275 3.74s-2.014.575-4.028.575h-80.639c-2.015 0-2.855.471-2.855.471l-4.236-3.857z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="uGradChevy"
          x1="-1702.333"
          x2="-1701.334"
          y1="-85.482"
          y2="-85.482"
          gradientTransform="matrix(44.9451 77.8472 76.4595 -44.1438 83459.313 129160.234)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#8ca0b5" />
          <stop offset=".14" stopColor="#e1e8f5" />
          <stop offset=".14" stopColor="#e1e8f5" />
          <stop offset=".815" stopColor="#7f97b4" />
          <stop offset=".904" stopColor="#476886" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#uGradChevy)"
          d="M440.635 470.478s.355-1.97-.316-3.309c-.669-1.338-24.138-47.495-25.198-49.615-1.062-2.119-3.457-2.9-3.457-2.9l2.675-5.348s.947.72 1.507 1.447c.557.724 29.434 59.484 30.327 61.545.89 2.063.107 2.809.107 2.809l-5.645-4.629z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="vGradChevy"
          x1="-1698.064"
          x2="-1697.064"
          y1="-76.096"
          y2="-76.096"
          gradientTransform="matrix(15.9191 9.1909 9.0271 -15.6353 28118.58 14827.911)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#002334" />
          <stop offset=".815" stopColor="#a5b9cc" />
          <stop offset=".815" stopColor="#a5b9cc" />
          <stop offset=".888" stopColor="#002334" />
          <stop offset="1" stopColor="#002334" />
        </linearGradient>
        <path
          fill="url(#vGradChevy)"
          d="M409.175 414.257c-3.082 0-20.42-.132-20.42-.132l24.658-5.007s1.542.637 2.313 1.927c.772 1.284-.003 1.668-.9.898-.897-.775-2.438.509-1.67 1.409.773.904 1.541 3.729 1.541 3.729-.001.001-2.438-2.824-5.522-2.824"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="wGradChevy"
          x1="-1698.748"
          x2="-1697.748"
          y1="-88.127"
          y2="-88.127"
          gradientTransform="matrix(52.0677 -52.0676 -51.1395 -51.1394 84126.617 -92519.203)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4bc7b" />
          <stop offset=".332" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#wGradChevy)"
          d="M179.792 418.23c-16.148-1.078-21.305-4.131-21.305-4.131h77.112c8.769 0 7.768-1.199 7.719-1.253l6.278 6.639s-15.252 0-24.942.178c-1.232.022-2.614.033-4.123.033-10.357 0-26.643-.528-40.739-1.466m63.524-5.386l.002.002-.002-.002z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="xGradChevy"
          x1="-1702.009"
          x2="-1701.009"
          y1="-83.623"
          y2="-83.623"
          gradientTransform="matrix(-37.191 -37.1909 36.528 -36.5279 -59852.93 -65922.172)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4bc7b" />
          <stop offset=".332" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#xGradChevy)"
          d="M361.673 419.663c-6.86-.178-17.662-.178-17.662-.178l7.199-6.779s.741 1.587 7.093 1.587c6.356 0 52.158.157 52.158.157s.773 2.504-12.714 3.466c-10.624.759-26.656 1.765-34.406 1.765a70.17 70.17 0 0 1-1.668-.018"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="yGradChevy"
          x1="-1701.93"
          x2="-1700.93"
          y1="-85.283"
          y2="-85.283"
          gradientTransform="matrix(-60.1132 -60.1131 59.0416 -59.0415 -96857.867 -106850.781)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4bc7b" />
          <stop offset=".332" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#yGradChevy)"
          d="M345.357 465.663s10.805 0 17.667-.179c6.862-.179 48.455 1.707 59.895 2.785 11.439 1.076 15.088 4.128 15.088 4.128s-72.724-.388-79.078-.388c-6.35 0-5.464 1.259-5.464 1.259l-8.108-7.605z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="zGradChevy"
          x1="-1680.564"
          x2="-1679.564"
          y1="-68.347"
          y2="-68.347"
          gradientTransform="matrix(7.852 0 0 -7.712 13442.642 -121.214)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d3bd8b" />
          <stop offset="1" stopColor="#7f5f39" />
        </linearGradient>
        <path
          fill="url(#zGradChevy)"
          d="M245.367 410.208s.771-2.502.771-4.429v-8.668c0-2.311.772-3.469.772-3.469l6.549 6.552s-.978 2.31-.978 4.044v9.773c0 2.26-.564 4.098-.564 4.098l-6.55-7.901z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="AGradChevy"
          x1="-1723.037"
          x2="-1722.037"
          y1="-68.35"
          y2="-68.35"
          gradientTransform="matrix(-7.8535 0 0 -7.7134 -13184.24 -121.248)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d3bd8b" />
          <stop offset="1" stopColor="#7f5f39" />
        </linearGradient>
        <path
          fill="url(#AGradChevy)"
          d="M341.468 414.066c0-2.26-.152-8.308-.152-10.044 0-1.729-.398-3.828-.398-3.828l6.548-6.552s.773 1.159.773 3.469v8.668c0 1.927.77 4.429.77 4.429l-7.013 8.083a18.25 18.25 0 0 1-.528-4.225"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="BGradChevy"
          x1="-1694.454"
          x2="-1693.454"
          y1="-90.373"
          y2="-90.373"
          gradientTransform="matrix(14.5943 -25.2781 -24.8275 -14.3341 22754.318 -43724.582)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset=".646" stopColor="#d3bd8b" />
          <stop offset=".888" stopColor="#ffe4a6" />
          <stop offset="1" stopColor="#ffe4a6" />
        </linearGradient>
        <path
          fill="url(#BGradChevy)"
          d="M249.029 392.874l47.773-.384.193.004v6.398l-41.61.15-6.356-6.168z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="CGradChevy"
          x1="-1700.306"
          x2="-1699.306"
          y1="-95.005"
          y2="-95.005"
          gradientTransform="matrix(-15.9434 -27.6148 -27.1225 15.6592 -29359.637 -45062.52)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset=".455" stopColor="#d3bd8b" />
          <stop offset=".888" stopColor="#ffe4a6" />
          <stop offset="1" stopColor="#ffe4a6" />
        </linearGradient>
        <path
          fill="url(#CGradChevy)"
          d="M297.187 398.892h-.192v-6.398l49.122.57-7.897 5.978-41.033-.15z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="DGradChevy"
          x1="-1701.575"
          x2="-1700.575"
          y1="-83.171"
          y2="-83.171"
          gradientTransform="matrix(33.7021 33.702 33.1013 -33.1012 60360.492 55073.516)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4bc7b" />
          <stop offset=".039" stopColor="#7f5f39" />
          <stop offset=".107" stopColor="#d1ac75" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#DGradChevy)"
          d="M249.674 494.521c-1.349 0-2.597-.727-2.597-.727l6.332-6.23s.624 1.353 5.086 1.353h38.692v5.604h-47.513z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="EGradChevy"
          x1="-1706.441"
          x2="-1705.441"
          y1="-88.205"
          y2="-88.205"
          gradientTransform="matrix(-34.2909 34.2908 -33.6796 -33.6795 -61152.164 56024.156)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4bc7b" />
          <stop offset=".039" stopColor="#7f5f39" />
          <stop offset=".107" stopColor="#d1ac75" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#EGradChevy)"
          d="M297.187 494.521v-5.604h38.692c4.462 0 5.386-1.942 5.386-1.942l6.33 6.227s-1.544 1.319-2.893 1.319h-47.515z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="FGradChevy"
          x1="-1700.71"
          x2="-1699.71"
          y1="-74.64"
          y2="-74.64"
          gradientTransform="matrix(12.5321 11.6863 11.478 -12.3087 22414.164 19432.185)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffe292" />
          <stop offset=".157" stopColor="#d1ac75" />
          <stop offset="1" stopColor="#ffe292" />
        </linearGradient>
        <path
          fill="url(#FGradChevy)"
          d="M245.87 489.078v-11.313c0-1.342-.589-2.932-.589-2.932l6.201-7.038s.419.585.419 3.516c0 2.933.25 14.41.25 14.41l-6.199 6.954s-.082-1.839-.082-3.597"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="GGradChevy"
          x1="-1714.41"
          x2="-1713.41"
          y1="-88.148"
          y2="-88.148"
          gradientTransform="matrix(-13.0643 12.1826 -11.9655 -12.8314 -23101.313 20230.908)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffe292" />
          <stop offset=".157" stopColor="#d1ac75" />
          <stop offset="1" stopColor="#ffe292" />
        </linearGradient>
        <path
          fill="url(#GGradChevy)"
          d="M341.524 485.586V471.52c0-2.932 1.371-3.725 1.371-3.725l7.578 7.634s-.988 1.597-.988 2.935c0 1.342-.064 9.521-.064 11.28 0 1.759.077 3.386.077 3.386l-7.974-7.444z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="HGradChevy"
          x1="-1701.606"
          x2="-1700.607"
          y1="-83.839"
          y2="-83.839"
          gradientTransform="matrix(39.1494 39.1494 38.4515 -38.4514 70041.828 63846.355)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#bd9b6a" />
        </linearGradient>
        <path
          fill="url(#HGradChevy)"
          d="M240.744 471.857h-53.166c-1.541 0-4.047-.578-4.817-1.35l4.817-5.009s1.347.962 4.623.962h55.285c1.543 0 3.082.581 3.082.581l-6.162 6.355s-1.543-1.539-3.662-1.539"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="IGradChevy"
          x1="-1692.252"
          x2="-1691.253"
          y1="-88.447"
          y2="-88.447"
          gradientTransform="matrix(16.6564 -16.6563 -16.3594 -16.3594 27154.004 -29185.807)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#d4bc7b" />
        </linearGradient>
        <path
          fill="url(#IGradChevy)"
          d="M406.337 420.335s2.977 1.12 3.908-2.416c0 0 .744-1.119 2.79 1.861 2.046 2.976 21.4 42.785 21.208 43.349-.187.556-4.094 1.302-4.094 1.302l-23.812-44.096z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="JGradChevy"
          x1="-1702.524"
          x2="-1701.524"
          y1="-85.197"
          y2="-85.197"
          gradientTransform="matrix(36.7534 70.7931 69.5312 -36.0982 68907.438 117867.664)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#a78a5e" />
          <stop offset=".764" stopColor="#7f5f39" />
          <stop offset=".916" stopColor="#674c2b" />
          <stop offset="1" stopColor="#674c2b" />
        </linearGradient>
        <path
          fill="url(#JGradChevy)"
          d="M430.71 464.054c.933-.556 1.862-1.302.56-4.091-1.301-2.786-16.186-31.813-19.346-37.392-3.163-5.58-.376-7.813-.376-7.813s2.422 1.119 3.149 2.325c.734 1.21 23.459 46.23 25.024 49.253 1.564 3.024.479 4.234.479 4.234l-9.49-6.516z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="KGradChevy"
          x1="-1703.176"
          x2="-1702.176"
          y1="-87.786"
          y2="-87.786"
          gradientTransform="matrix(-104.4677 124.4997 122.2803 102.6053 -166805.688 221456.094)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffefcf" />
          <stop offset=".461" stopColor="#ffe4a6" />
          <stop offset="1" stopColor="#bc956e" />
        </linearGradient>
        <path
          fill="url(#KGradChevy)"
          d="M297.187 488.869v-89.977h39.786c2.305 0 4.325.865 4.325 3.466v13.419c0 2.595 1.728 4.609 3.749 4.609h60.019c2.106 0 3.998 1.233 5.095 3.261 4.904 9.068 18.411 35.365 19.433 37.485 1.248 2.588.476 4.087-2.416 4.087h-79.537c-3.46 0-6.059 2.593-6.059 5.766v14.709c0 2.019-1.153 3.174-3.747 3.174h-40.648v.001z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="LGradChevy"
          x1="-1701.59"
          x2="-1700.59"
          y1="-83.491"
          y2="-83.491"
          gradientTransform="matrix(36.1127 36.1127 35.469 -35.4689 64565.156 58908.656)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#e9cf98" />
        </linearGradient>
        <path
          fill="url(#LGradChevy)"
          d="M157.837 416.603l7.7 4.669s-.882.384.504 3.159c1.388 2.775 14.389 29.283 14.389 29.283l-2.901.628-19.692-37.739z"
        />
      </g>
      <g transform="matrix(1.32585 0 0 -1.30221 -194.163 651.935)">
        <linearGradient
          id="MGradChevy"
          x1="-1701.644"
          x2="-1700.645"
          y1="-84.645"
          y2="-84.645"
          gradientTransform="matrix(48.631 48.6309 47.764 -47.764 86945.617 79132.203)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7f5f39" />
          <stop offset="1" stopColor="#e4cb90" />
        </linearGradient>
        <path
          fill="url(#MGradChevy)"
          d="M157.14 420.035c-1.927-3.468-1.539-4.814-1.539-4.814l4.622 3.082s20.611 39.875 22.73 44.5c2.12 4.622-1.039 6.505-1.039 6.505s-22.847-45.806-24.774-49.273"
        />
      </g>
      <path
        fill="#fff"
        d="M18.316 112.904c-.405.267-4.14.72-4.87 0-.731-.712-1.952-1.27-.977-2.07.978-.801 12.99-7.814 12.99-7.814s-1.459.796 10.884.796h98.733c2.599 0 5.033 1.752 5.36 2.869.325 1.119-.326 1.595-1.137 1.439-.809-.162-2.923-.8-3.41-1.6-.487-.795.65-1.433-6.497-1.433-7.145 0-61.708.8-74.047 1.914-12.343 1.119-28.587.32-37.029 5.9M383 36.982c.404-.262 4.144-.714 4.873 0 .73.718 1.95 1.276.975 2.075-.975.796-12.991 7.814-12.991 7.814s1.457-.796-10.883-.796h-98.736c-2.598 0-5.033-1.751-5.356-2.87-.326-1.12.322-1.6 1.13-1.438.819.162 2.927.8 3.416 1.594.485.801-.653 1.434 6.495 1.434s61.704-.794 74.052-1.91c12.338-1.118 28.584-.318 37.024-5.903M50.194 46.209c0-1.129.638-3.26.129-3.884-.512-.63 1.02-1.382 2.043-.758 1.022.629 3.191 1.129 3.446 1.633.256.5-.127 1.752-1.531 2.256-1.406.5-2.683 1.63-4.853 6.267-2.172 4.646-14.56 28.224-14.56 28.224s1.79-3.761 1.023-3.89c-.766-.124-2.552 3.013-2.552 3.013L50.194 46.21zM135.581 43.99c-1.057.105-1.352-1.032-.45-1.18.906-.149 2.106-.22 3.158-4.286 1.056-4.066.304-16.402.152-18.617-.152-2.217-1.203-4.875.304-6.056 1.502-1.185 2.556 1.33 6.468 1.33 3.91 0 12.788-.296 12.788-.296s-12.487.881-14.596 1.18c-2.105.297-3.911 1.92-3.612 4.876.304 2.956-.448 18.178-1.048 19.802-.604 1.624-1.659 3.1-3.164 3.248M219.826 14.976c-1.657.075 31.723.385 33.826.385 2.106 0 4.513.628 4.966 2.694.451 2.072.131 8.853.131 8.853s1.037-8.704 2.543-10.328c1.504-1.63 1.053-3.99-.902-3.552-1.957.448-17.447.924-40.564 1.948M264.4 105.563c-1.05-.153-2.25-.294-2.554.59-.301.88 1.35 1.471-.301 2.352-1.647.886-2.876 1.43-2.876.691 0-.738.851-4.524 4.004-4.524 3.153 0 80.954-.146 82.162-.146 1.196 0 2.699.146 3.297 1.329.6 1.18 1.35 4.126 1.803 5.013.447.884-.3.884-1.655-.887-1.35-1.77-4.798-2.504-7.497-2.357-2.704.147-76.383-2.061-76.383-2.061M350.232 108.067s-.748-1.619-1.2-2.657c-.45-1.028-1.8-1.466-1.8-1.466s1.499-1.775 3.598-5.603c2.104-3.828 12.008-22.11 13.057-24.616 0 0-2.251 6.786 2.101 1.18 0 0-14.105 26.231-15.007 28.002-.898 1.771-.75 5.16-.75 5.16M141.523 128.697s.179 2.12-1.074 3c-1.254.881-1.794 2.466-.717 3.173 1.076.704 1.793.352 2.51-.707.718-1.055 3.232-1.938 4.845-1.584.002-.001-5.564.698-5.564-3.882M218.86 132.473s30.282 1.567 32.076 1.649l3.049.137s-3.213-.5-2.263-1.514l-32.863-.272zM254.75 132.226s-.895 1.409.538 2.11c1.439.704 2.876 1.408 3.772.352.895-1.056-.717-3.875-.54-5.813 0-.001.718 2.998-3.77 3.35"
      />
      <path d="M291.685 134.777h-1.677v2.791h1.677c.854 0 1.107-.333 1.107-.881v-1.033c0-.705-.334-.877-1.107-.877m0 3.695h-1.677v2.296h-1.02v-6.91h2.697c1.528 0 2.127.668 2.127 1.797v1.033c0 .749-.264 1.253-1.02 1.586l1.892 2.494h-1.207l-1.792-2.296zm-.314 4.4c3.601 0 5.492-2.425 5.492-5.4 0-2.976-1.89-5.437-5.492-5.437-3.605 0-5.54 2.461-5.54 5.437 0 2.975 1.934 5.4 5.54 5.4m0-11.75c3.99 0 6.428 2.834 6.428 6.338 0 3.455-2.437 6.331-6.428 6.331-4.015 0-6.473-2.876-6.473-6.331 0-3.504 2.458-6.338 6.473-6.338M86.098 176.671H74.956v-13.928H64.203v34.626h10.753v-14.93h11.142v14.93h10.764v-34.628H86.098v13.93zM283.916 191.604V162.74H273.16v34.626h26.15v-5.762h-15.394zM345.066 162.74v5.777h9.789v28.852h10.75v-28.852h9.796v-5.776h-30.335zM25.402 169.95c0-4.327 2.662-7.21 6.654-7.21h21.57v5.77H38.162c-1.202 0-1.993.875-1.993 2.169v18.752c0 1.302.79 2.174 1.993 2.174h15.464v5.762h-21.57c-3.992 0-6.654-2.889-6.654-7.211V169.95zM212.49 183.32l9.298 14.047h-11.434l-8.232-14.283v-4.514h4.444c1.197 0 1.994-.877 1.994-2.169v-5.725c0-1.293-.797-2.162-1.994-2.162h-7.525v28.853H188.28v-34.626h24.388c4.003 0 6.652 2.882 6.652 7.21l.01 6.997c.001 3.814-2.342 6.372-5.875 6.372h-.964zM249.779 191.604c1.19 0 1.99-.87 1.99-2.167v-18.76c0-1.291-.8-2.167-1.99-2.167h-7.503c-1.196 0-2 .876-2 2.167v18.76c0 1.297.804 2.167 2 2.167h7.503zM229.52 169.95c0-4.328 2.652-7.21 6.646-7.21h19.711c3.988 0 6.656 2.882 6.656 7.21v20.207c0 4.322-2.668 7.21-6.656 7.21h-19.711c-3.994 0-6.646-2.888-6.646-7.21V169.95zM144.727 162.74h11.537l6.885 26.77a.461.461 0 0 0 .477.388c.244 0 .435-.145.48-.388l6.694-26.77h9.029l-8.34 29.715c-1.01 3.383-2.834 4.912-6.664 4.912h-5.37c-2.463 0-4.471-1.248-5.678-4.937l-9.05-29.69zM118.493 190.51c0 .665.397 1.088 1.002 1.088h17.679v5.77h-22.791c-3.99 0-6.65-2.89-6.65-7.205v-20.21c0-4.328 2.66-7.212 6.65-7.212h22.791v5.776h-17.68c-.605 0-1.003.43-1.003 1.082v7.065h16.652v5.774h-16.65v8.073zM317.564 190.51c0 .665.394 1.088.988 1.088h17.688v5.77h-22.794c-3.988 0-6.663-2.89-6.663-7.205v-20.21c0-4.328 2.674-7.212 6.663-7.212h22.793v5.776h-17.687c-.594-.002-.988.428-.988 1.082v7.065h16.64v5.774h-16.64v8.073z" />
    </svg>
  );
}
export default ChevroletIcon;
